import React from 'react';

export default function (props) {
    return (
        <svg version="1.1" id="Capa_1" x="0px" y="0px"
            viewBox="0 0 50 50" style={{enableBackground:'new 0 0 50 50'}}>
            <circle style={{fill: props.fill}} cx="25" cy="25" r="25"/>
            <polyline style={{fill:'none',stroke:'#FFFFFF',strokeWidth:2,strokeLinecap:'round',strokeMiterlimit:10}} points="16,34 25,25 34,16"/>
            <polyline style={{fill:'none',stroke:'#FFFFFF',strokeWidth:2,strokeLinecap:'round',strokeMiterlimit:10}} points="16,16 25,25 34,34"/>
        </svg>
    );
}


// WEBPACK FOOTER //
// ./src/Components/assets/Close.js